import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';

const WidgetCustomizationModal = ({
  isOpen,
  onClose,
  currentSettings,
  onSave,
  isIBRole
}) => {
  const [settings, setSettings] = useState(currentSettings || {});

  useEffect(() => {
    if (isOpen) {
      setSettings(currentSettings || {});
    }
  }, [isOpen, currentSettings]);

  const handleChange = (field, value) => {
    setSettings(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(settings);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-sm">
      <div className="bg-white rounded-lg w-full max-w-md p-6 max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-primary">Widget Settings</h2>
          <button
            onClick={onClose}
            className="p-1 rounded-full hover:bg-gray-100"
          >
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          {/* AI Prompt Customization */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              AI Summary Prompt
            </label>
            <textarea
              value={settings.summaryPrompt || ""}
              onChange={(e) => handleChange('summaryPrompt', e.target.value)}
              className="w-full p-2 border border-gray-300 rounded-md min-h-[100px]"
              placeholder="Generate a concise summary of the client's portfolio and key insights..."
            />
            <p className="text-xs text-gray-500 mt-1">
              Customize the prompt sent to the AI for generating client summaries.
            </p>
          </div>

          {/* <div className="mb-4">
            <h3 className="font-medium text-gray-700 mb-2">Display Options</h3>

            <div className="space-y-2">
              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={settings.showShortSummary !== false}
                  onChange={(e) => handleChange('showShortSummary', e.target.checked)}
                  className="mr-2"
                />
                <span className="text-sm">Show Short Summary</span>
              </label>

              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={settings.showLongSummary !== false}
                  onChange={(e) => handleChange('showLongSummary', e.target.checked)}
                  className="mr-2"
                />
                <span className="text-sm">Show Long Summary</span>
              </label>

              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={settings.showClientSelector !== false}
                  onChange={(e) => handleChange('showClientSelector', e.target.checked)}
                  className="mr-2"
                />
                <span className="text-sm">Show Client Selector</span>
              </label>

              <label className="flex items-center">
                <input
                  type="checkbox"
                  checked={settings.showScheduleButton !== false}
                  onChange={(e) => handleChange('showScheduleButton', e.target.checked)}
                  className="mr-2"
                />
                <span className="text-sm">Show Schedule Call Button</span>
              </label>
            </div>
          </div> */}

          {/* Metrics Customization */}
          <div className="mb-4">
            <h3 className="font-medium text-gray-700 mb-2">Metrics Display</h3>
            <p className="text-xs text-gray-500 mb-2">
              Select which metrics to display in the bottom section
            </p>

            <div className="grid grid-cols-2 gap-2">
              {(isIBRole ? [
                { id: 'proxyYtd', label: 'Proxy YTD' },
                { id: 'pipelineWeight', label: 'Pipeline Weight' },
                { id: 'engagementScore', label: 'Engagement Score' },
                { id: 'openAlerts', label: 'Open Alerts' },
              ] : [
                { id: 'aum', label: 'Total AUM' },
                { id: 'ytdReturn', label: 'YTD Return' },
                { id: 'timeHorizon', label: 'Time Horizon' },
                { id: 'lastContact', label: 'Last Contact' },
                { id: 'riskTolerance', label: 'Risk Tolerance' },
                { id: 'investmentGoal', label: 'Investment Goal' },
                { id: 'nextReview', label: 'Next Review' },
                { id: 'clientSince', label: 'Client Since' },
              ]).map(metric => (
                <div key={metric.id} className="border rounded-md p-2">
                  <label className="flex items-center justify-between">
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        checked={settings.metrics?.[metric.id] !== false}
                        onChange={(e) => handleChange('metrics', {
                          ...(settings.metrics || {}),
                          [metric.id]: e.target.checked
                        })}
                        className="mr-2"
                      />
                      <span className="text-sm">{metric.label}</span>
                    </div>
                    {/* <button
                      type="button"
                      onClick={() => {
                        const newTooltip = prompt("Edit tooltip text:", metric.tooltip);
                        if (newTooltip !== null) {
                          handleChange('tooltips', {
                            ...(settings.tooltips || {}),
                            [metric.id]: newTooltip
                          });
                        }
                      }}
                      className="text-xs text-primary hover:underline"
                    >
                      Edit Tooltip
                    </button> */}
                  </label>
                </div>
              ))}
            </div>
          </div>

          <div className="flex justify-end gap-2 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-secondary text-white rounded-md text-sm font-medium hover:bg-primaryLight"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default WidgetCustomizationModal;